/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsGet } from "../../funcs/llmConversationsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsRetrieveRequest$inboundSchema,
};

export const tool$llmConversationsGet: ToolDefinition<typeof args> = {
  name: "llm-conversations-get",
  description: `Retrieve a conversation

Get a conversation by ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
